<template>
  <Teleport to="body">
    <div
      v-if="currentStep"
      class="legal-consent"
      role="dialog"
      aria-modal="true"
      aria-describedby="legal-consent-desc"
    >
      <p
        id="legal-consent-desc"
        class="legal-consent__desc"
        v-html="currentStep.description"
      />
      <button
        type="button"
        class="legal-consent__btn"
        @click="accept"
      >
        Принимаю
      </button>
    </div>
  </Teleport>
</template>

<script>
import {
  LEGAL_CONSENT_STEPS,
  loadAcceptedCategories,
  saveAcceptedCategories,
} from '@/config/legalConsentSteps';

export default {
  name: 'LegalConsent',
  data() {
    return {
      accepted: loadAcceptedCategories(),
    };
  },
  computed: {
    currentStep() {
      return LEGAL_CONSENT_STEPS.find(
        (step) => !this.accepted.includes(step.id),
      ) ?? null;
    },
  },
  methods: {
    accept() {
      const step = this.currentStep;
      if (!step) {
        return;
      }

      this.accepted = [...this.accepted, step.id];
      saveAcceptedCategories(this.accepted);
    },
  },
};
</script>

<style scoped>
.legal-consent {
  position: fixed;
  bottom: 1.25rem;
  left: 50%;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  width: min(85%, 72rem);
  padding: 1rem 1.75rem;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.12);
  transform: translateX(-50%);
}

.legal-consent__desc {
  flex: 1;
  margin: 0;
  color: #1a1a1a;
  font-size: 0.875rem;
  line-height: 1.45;
}

.legal-consent__desc :deep(a) {
  color: #216fbd;
  text-decoration: underline;
}

.legal-consent__desc :deep(a:hover) {
  color: #1a5a9e;
}

.legal-consent__btn {
  flex-shrink: 0;
  padding: 0.55rem 1.25rem;
  border: none;
  border-radius: 4px;
  background: #216fbd;
  color: #fff;
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.legal-consent__btn:hover {
  background: #1a5a9e;
}

@media (max-width: 768px) {
  .legal-consent {
    width: calc(100% - 2rem);
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
    padding: 1rem 1.25rem;
  }

  .legal-consent__btn {
    width: 100%;
    padding: 0.65rem 1rem;
    text-align: center;
  }
}
</style>
